import { MaterialReactTable, MRT_GlobalFilterTextField, useMaterialReactTable } from 'material-react-table';
import { Box, Button, lighten, Stack, Tooltip } from '@mui/material';
import { RemoveRedEye } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { language_PT_BR } from '@/components/Base/CustomLocales/language_PT_BR.ts';

const TableTermometroFinanceiro = ({ 
  type, data, route 
}: { type: any, data: any, route?: any }) => {
  const navigate = useNavigate();

  const columns = [
    {
      accessorKey: 'student__nome',
      header: 'Aluno',
      sortDescFirst: true,
      enableMultiSort: true,
      size: 130,
      Cell: ({ renderedCellValue }) => <Tooltip title={renderedCellValue} sx={{
              padding: '0 10px',
            }}><Box>{renderedCellValue}</Box></Tooltip>,
    },
    {
      accessorKey: 'score_value',
      header: type === 'high' ? 'Score alto' : type === 'intermediary' ? 'Score intermediário' : 'Score baixo',
      size: 10,
      Cell: ({ renderedCellValue }) => (
        <Box
          sx={{
            backgroundColor:
              type === 'high' ? 'rgba(206, 250, 206, 1)' : type === 'intermediary' ? '#FEF8CB' : '#FCE4D4',
            height: '60px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '5px',
          }}
        >
          {renderedCellValue}
        </Box>
      ),
    },
    {
      accessorKey: 'student_id',
      header: 'ID',
      enableHiding: true,
      enableSorting: false,
      enableResizing: false,
      size: 0,
    },
  ];

  const tableBasic = useMaterialReactTable({
    columns,
    data,
    localization: language_PT_BR,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableRowActions: true,
    enableRowSelection: false,
    enableBottomToolbar: false,
    enableGlobalFilter: false,
    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: false,
      variant: 'outlined',
    },
    initialState: {
      showGlobalFilter: false,
      columnVisibility: {
        'student_id': false,
      },
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    renderRowActions: ({ row }) => {
      const studentId = data[row.index].student_id;
      const nameStudent = data[row.index].student__nome;

      return (
        <Stack alignItems={'center'} style={{cursor: 'pointer'}}>
          <RemoveRedEye
            onClick={() => navigate(route ? route + `/${studentId}` : '/termometro-geral-aluno-financeiro', { state: { id: studentId, name: nameStudent } })}
          />
        </Stack>
      );
    },
    muiTableHeadCellProps: ({ column }) => {
      return {
        sx: {
          color: 'black',
          fontWeight: 400,
          fontSize: '12px',
          textAlign: column.id === 'mrt-row-select' ? 'center' : 'left',
          padding: column.id === 'mrt-row-select' ? '16px' : undefined,
        },
      };
    },
    muiTableBodyCellProps: ({ column }) => {
      return {
        sx: {
          backgroundColor: '#fff',
          color: 'rgba(128, 128, 128, 1)',
          fontWeight: 400,
          fontSize: '12px',
          padding: '0',
          textAlign: column.id === 'mrt-row-select' ? 'center' : 'left',
        },
      };
    },
    renderTopToolbar: ({ table }) => {
      const handleDeactivate = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('deactivating ' + row.getValue('name'));
        });
      };

      const handleActivate = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('activating ' + row.getValue('name'));
        });
      };

      const handleContact = () => {
        table.getSelectedRowModel().flatRows.map((row) => {
          alert('contact ' + row.getValue('name'));
        });
      };

      return (
        <Box
          sx={(theme) => ({
            backgroundColor: lighten(theme.palette.background.default, 0.05),
            display: 'none',
            gap: '0.5rem',
            p: '8px',
            justifyContent: 'space-between',
            width: '100%'
          })}
        >
          <Box sx={{ borderRadius: '20px' }}>
            <MRT_GlobalFilterTextField table={table} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                color="error"
                disabled={!tableBasic.getIsSomeRowsSelected()}
                onClick={handleDeactivate}
                variant="contained"
              >
                Deactivate
              </Button>
              <Button
                color="success"
                disabled={!table.getIsSomeRowsSelected()}
                onClick={handleActivate}
                variant="contained"
              >
                Activate
              </Button>
              <Button
                color="info"
                disabled={!table.getIsSomeRowsSelected()}
                onClick={handleContact}
                variant="contained"
              >
                Contact
              </Button>
            </Box>
          </Box>
        </Box>
      );
    },
  });

  return (
    <Box
      sx={{
        maxHeight: '600px',
        overflowY: 'auto',

        border: '1px solid #B3B3B3',
        borderRadius: '5px',

        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555',
        },
      }}
    >
      <MaterialReactTable table={tableBasic} />
    </Box>
  );
};

export default TableTermometroFinanceiro;
